/**
 * Extract validation error.
 * @param {string | string[] | undefined} error Error to extract.
 * @returns {string | undefined}
 */
export function extractValidationError(error) {
  if (error === undefined) {
    return undefined;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (Array.isArray(error)) {
    // Return first error if error is an array.
    return error.at(0);
  }
  throw new Error(`Invalid validation error type. Expect string, undefined or an array of string, received: ${typeof error} `);
}
